import React, {useEffect, useState} from 'react'
import Select from 'react-select'

type DropdownProps = {
  fieldName: string
  optionList: any
  handleSelectedItem: any
  fieldDisabled?: boolean
  formik?: any
  selectedVal?: any
  data?: any
  hasError?: any
  className?: string
  isSolarProduct?: boolean
}

const Dropdown = ({
  fieldName,
  optionList,
  handleSelectedItem,
  fieldDisabled,
  formik,
  selectedVal,
  data,
  hasError = false,
  className = '',
  isSolarProduct,
}: DropdownProps) => {
  const [optionItems, setOptionItems] = useState<any>([])
  useEffect(() => {
    const tempList: any = [
      {
        value: '',
        label: 'Select option',
      },
    ]
    optionList?.forEach((element: any, idx: number) => {
      tempList.push({
        value: fieldName === 'script' ? element.scriptId : element.id,
        label: fieldName === 'script' ? element.scriptName : element.value,
        isDisabled: Boolean(element.isDisabled) ? element.isDisabled : false,
      })
    })

    setOptionItems(tempList)
    // }
  }, [fieldName, optionList, hasError])
  const handleDropdownValue = (objList: any) => {
    let optionItem: any
    if (optionList?.length > 0) {
      optionList?.forEach((element: any, idx: number) => {
        if (fieldName === 'script') {
          if (element.scriptName.toLowerCase() === formik.values[fieldName]?.toLowerCase()) {
            optionItem = {
              value: element.scriptId,
              label: element.scriptName,
            }
          }
        } else if (!formik && selectedVal) {
          // Below code is used for state and country
          if (element.value === selectedVal) {
            optionItem = {
              value: element.id,
              label: element.value,
            }
          }
        } else {
          if (
            element.value?.toLowerCase() === formik.getFieldMeta(fieldName).value?.toLowerCase()
          ) {
            optionItem = {
              value: element.id,
              label: element.value,
            }
          }
        }
      })
    } else {
      optionItem = null
    }
    return !formik && selectedVal ? optionItem : optionItem || null
  }
  return (
    <>
      <Select
        id={fieldName}
        className={`basic-single ${className}`}
        classNamePrefix='dropdown'
        menuShouldScrollIntoView={false}
        // isClearable
        isSearchable
        name={fieldName}
        defaultValue={handleDropdownValue(optionItems)}
        value={handleDropdownValue(optionItems)}
        options={optionItems}
        onChange={(e: any) => {
          handleSelectedItem(e, fieldName)
        }}
        isDisabled={fieldDisabled}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({...base, zIndex: 9999}),
          control: (base) => ({
            ...base,
            height: 44,
            minHeight: 44,
          }),
        }}
      />
      {formik
        ? // Error message for field which use formik
          formik.values[fieldName] === '' &&
          formik.errors[fieldName] &&
          formik.touched[fieldName] && (
            <div className='fv-plugins-message-container'>
              <div data-field='appname' data-validator='notEmpty' className='fv-help-block'>
                {formik.errors[fieldName]}
              </div>
            </div>
          )
        : // Error message for field which doesn't use formik
          !data && hasError && <div className='text-danger'>{fieldName} is required</div>}
    </>
  )
}

export default Dropdown